module.exports = __webpack_public_path__ + "a0d9e1cebf35de495c1fce0b14e40b83.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/images/navigators/ic-anchor-token.svg
// module id = 1493
// module chunks = 3